import { render } from "./ModalRoomPrice.vue?vue&type=template&id=292ad28e"
import script from "./ModalRoomPrice.vue?vue&type=script&lang=js"
export * from "./ModalRoomPrice.vue?vue&type=script&lang=js"

import "./ModalRoomPrice.vue?vue&type=style&index=0&id=292ad28e&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__